export default __webpack_public_path__ + "static/media/hht1_ep8_minisitcom_01.af0bcad4.png";